module.exports = "https://portperrypedals.ca/_res/img/media-gone-mad.2e79746.png";